/**
 * Enhanced details to create a features list that supports having a single piece of media that gets switched
 * TODO: add video support
 *
 * @version 	2025.11.04
 * @name   		CSlice\JS\Details-Features
 */

document.addEventListener('DOMContentLoaded', () => {
	const detailsElements = document.querySelectorAll('.details-features');

	if (detailsElements.length === 0) return;

	// Group details by their name attribute
	const groups = new Map();
	detailsElements.forEach((detail) => {
		const groupName = detail.getAttribute('name');
		if (!groupName) return;

		if (!groups.has(groupName)) {
			groups.set(groupName, {
				details: [],
				target: document.getElementById(groupName),
				targetImage: null,
			});
		}

		const group = groups.get(groupName);
		group.details.push(detail);

		// Cache the target image element
		if (group.target && !group.targetImage) {
			group.targetImage = group.target.querySelector('img');
		}
	});

	// Initialize each group
	groups.forEach((group) => {
		if (!group.targetImage) return;

		// Find first open detail or use first detail
		const openDetail = group.details.find((d) => d.open) || group.details[0];

		// Set initial image
		const initialImage = openDetail.querySelector('img');
		if (initialImage) {
			group.targetImage.src = initialImage.src;
		}

		// Open first detail if none are open
		if (!group.details.some((d) => d.open)) {
			openDetail.open = true;
		}

		// Add toggle listeners
		group.details.forEach((detail) => {
			detail.addEventListener('toggle', () => {
				if (!detail.open) return;

				const detailImage = detail.querySelector('img');
				if (detailImage) {
					group.targetImage.src = detailImage.src;
				}
			});
		});
	});
});

/**
 * Expanding list
 */
document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.is-style-expanding').forEach((list) => {
		if (list.querySelectorAll(':scope > li').length <= 6) return;
		list.classList.add('has-toggle');

		const toggle = document.createElement('button');
		toggle.className = 'expanding-list-toggle';
		toggle.textContent = 'Show more +';
		toggle.type = 'button';

		toggle.addEventListener('click', () => {
			const expanded = list.classList.toggle('is-expanded');
			toggle.textContent = expanded ? 'Show less -' : 'Show more +';
		});

		list.after(toggle);
	});
});
